import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import {
  Alert,
  Button,
  FormGroup,
  Form,
  Panel
} from 'react-bootstrap';
import {updateConnection} from "../../redux/actions/integrationsConnectionActions";
import request from 'superagent';
import {notify} from 'common/Notification';

export default function FileSyncUploadDestinationSettings({dispatch, connectionId, folderConfig}) {
  const onSave = (settings) => {
    return request.patch(`/rpc/integrations/connections/${connectionId}`)
      .send(settings)
      .then(
        res => {
          notify.success('PDF Destination setting saved');
          dispatch(updateConnection(connectionId, res.body));
        },
        errRes => {
          notify.error('Failed to save PDF destination settings');
        }
      );
  };

  return (
    <FinalForm
      onSubmit={settings => onSave(settings)}
      initialValues={{folder_config: folderConfig}}
    >
      {({handleSubmit, form, submitting, pristine, values}) =>
        <Form onSubmit={handleSubmit}>
          {/* <pre>VALUES: {JSON.stringify(values, null, 2)}</pre> */}
          <Panel>
            <Panel.Heading>
              <Panel.Title>Where do you want your PDFs to go?</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              {values.folder_config === 'none' &&
                <Alert bsStyle="warning">
                  <h4>Selection Required</h4>
                  <p>
                    No PDFs will be synced until you choose where you want to save your PDFs.
                  </p>
                </Alert>
              }

              <FormGroup>
                <label>
                  <Field name="folder_config" component="input" value="casefolder" type="radio" />{' '}
                  Upload PDFs to their corresponding client matter folders (configure your folder paths per case)<br/>
                  <b>NOTE:</b> PDFs will begin to upload as you configure each case in the CaseFolder settings.
                </label>

                <label>
                  <Field name="folder_config" component="input" value="connection" type="radio" />{' '}
                  Upload PDFs to a single folder with optional subfolders (configure your folder path below)<br/>
                  <b>NOTE:</b> PDFs will begin to upload 15 minutes after you save this selection.
                </label>
              </FormGroup>

              <Button bsStyle="primary" type="submit" disabled={pristine || submitting}>Save</Button>
            </Panel.Body>
          </Panel>
        </Form>
      }
    </FinalForm>
  );
}


// WEBPACK FOOTER //
// ./src/Integrations/connections/FileSyncUploadDestinationSettings.jsx